// @owners { team: patients-team }
import { type AddOnsEndpointFetchByProductIdsRequest } from '@alto/scriptdash/alto/patient_app/add_ons/v1/add_ons_endpoint';
import { get } from '~shared/helpers/apiHelper';
import { useQuery } from '~shared/react-query';

/**
 * @deprecated prefer using auto-generated endpoints directly with `apiEndpointHandler`
 * @see https://github.com/scriptdash/clients/pull/7913
 */
const addOnsFetchByProductIDs = async ({
  product_ids,
  address_id,
  facility_id,
}: AddOnsEndpointFetchByProductIdsRequest) => {
  return get(
    '/add_ons/fetch_by_product_ids',
    {
      product_ids,
      address_id,
      facility_id,
    },
    {
      version: 'v1',
      splitArrayParams: true,
    },
  ).then((response) => {
    if (response.error) {
      throw new Error(response.error);
    }

    return response;
  });
};

/**
 * @deprecated prefer using auto-generated endpoints directly with `apiEndpointHandler`
 * @see https://github.com/scriptdash/clients/pull/7913
 */
export const useAddOnsFetchByProductIDs = (
  productIDs: number[],
  addressID?: number,
  facilityID?: number,
  options?: object,
) => {
  return useQuery({
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @alto/prefer-query-key-factory
    queryKey: ['otcs', { addressID, facilityID, productIDs }],
    queryFn: () => addOnsFetchByProductIDs({ product_ids: productIDs, address_id: addressID, facility_id: facilityID }),
    ...(options || {}),
  });
};
